<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    center
    title="本地路由"
    :visible.sync="dialogVisible"
    width="500px"
  >
    <div>
      <el-input
        v-model="filterText"
        placeholder="请输入查询路由的title、name、path"
      />
      <div style="height: 60vh; overflow-y: auto">
        <el-tree
          ref="xzqhTree"
          show-checkbox
          :indent="5"
          node-key="path"
          :data="data"
          :props="defaultProps"
          check-strictly
          check-on-click-node
          :filter-node-method="filterNode"
          @check-change="handleCheckChange"
        >
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span>{{ data.meta ? data.meta.title : "" }} {{ data.path }}【{{
              data.name || "无name"
            }}】</span>
          </span>
        </el-tree>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitHandle">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MenuData from '@/router/data'
export default {
  name: 'LocalMenu',
  data() {
    console.log('menu', MenuData)
    return {
      filterText: '',
      dialogVisible: false,
      data: MenuData,
      current: {},
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.xzqhTree.filter(val)
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      if (data.path && data.path.indexOf(value) !== -1) {
        return true
      }
      if (data.name && data.name.indexOf(value) !== -1) {
        return true
      }
      return data.meta && data.meta.title && data.meta.title.indexOf(value) !== -1
    },
    submitHandle() {
      console.log(this.current)
      this.$emit('change', this.current)
      this.dialogVisible = false
    },
    show() {
      this.dialogVisible = true
    },
    // 单选
    handleCheckChange(data, checked, node) {
      console.log(data)
      if (checked) {
        this.current = data
        // 实现单选功能
        this.$refs.xzqhTree.setCheckedKeys([])
        this.$refs.xzqhTree.setCheckedKeys([data.path])
      }
    }
  }
}
</script>

<style>
</style>
